module.exports = __webpack_public_path__ + "img/noData.2db6ec06.png";